import {translateConnectionObjectToArray} from 'nutshell-core';

import type {Tag} from 'shells/tags-editor/tags-editor';

import type {
    ContactPageFragment_tagMaps_edges as ContactTagMapEdge,
    AccountPageFragment_tagMaps_edges as AccountTagMapEdge,
} from 'nutshell-graphql-types';

import {combineFetchedOptionsWithCurrentOptions} from '../../../../core/select/helpers';

export const usePeepTags = (
    tagMaps: ContactTagMapEdge[] | AccountTagMapEdge[],
    fetchTags: (arg1: string) => Promise<any>
) => {
    const tags = tagMaps ? getSelectedTagsFromTagMap(tagMaps) : [];

    const handleFetchTags = (searchTerm: string, currentTags: Tag[]) =>
        fetchTags(searchTerm)
            .then(({data}) => (data ? translateConnectionObjectToArray(data.tags) : []))
            .then((fetchedTags: Tag[]) =>
                combineFetchedOptionsWithCurrentOptions(fetchedTags, currentTags)
            );

    return {
        tags,
        handleFetchTags,
    };
};

function getSelectedTagsFromTagMap(tags: ContactTagMapEdge[] | AccountTagMapEdge[]): Tag[] {
    return tags.map((tag: ContactTagMapEdge | AccountTagMapEdge) => {
        return {
            id: tag.node?.id ?? '',
            name: tag.node?.name ?? '',
            color: tag.node?.color ?? '',
            creator: tag.node?.creator ?? null,
            createdTime: tag.node?.createdTime ?? null,
        };
    });
}
